export default __webpack_public_path__ + "static/shopify_service_features-6b27fabc98dc1c44f8b2848f49897cc5.svg";